import React from "react";

import TopBannerCard from "./banner/index";
import CarouselsCard from "./carousels/index";

const HomePageSettings = () => {
    return (
        <div className="col-12 col-md-9">
            <TopBannerCard />
            <CarouselsCard />
        </div>
    );
};

export default HomePageSettings;
